import { FC, HTMLAttributes } from 'react';
import classNames from 'classnames';
import { ReactComponent as TrRD } from 'src/Themes/assets/RedocTrober.svg';
import st from './ReDocTrober.module.scss';

interface IReDocTroberProps extends HTMLAttributes<HTMLDivElement> {
	/** Размер тробера */
	size?: 'sm' | 'lg' | 'xl';
}

/** Компонента тробера в виде ReDoc */
const ReDocTrober: FC<IReDocTroberProps> = ({
	size = 'sm',
	className,
	...otherProps
}) => {
	return (
		<div
			className={classNames(st.trober, className, st[size])}
			{...otherProps}
		>
			<TrRD width={100} height={100} />
		</div>
	);
};

export default ReDocTrober;
